import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=14876dcb&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=14876dcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14876dcb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14876dcb')) {
      api.createRecord('14876dcb', component.options)
    } else {
      api.reload('14876dcb', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=14876dcb&scoped=true&", function () {
      api.rerender('14876dcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pMciZiFBSF1W/JS/comp/PopupBox.vue"
export default component.exports